/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_S9_BodyInputs */

const en_fc_tut_s9_body = /** @type {(inputs: Fc_Tut_S9_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the text tool to place titles and lower thirds, and the shape and pen tools for simple graphics. Caption tracks keep subtitles editable and separate from your picture.`)
};

/**
* | output |
* | --- |
* | "Use the text tool to place titles and lower thirds, and the shape and pen tools for simple graphics. Caption tracks keep subtitles editable and separate from..." |
*
* @param {Fc_Tut_S9_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_s9_body = /** @type {((inputs?: Fc_Tut_S9_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_S9_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_s9_body(inputs)
});
export { fc_tut_s9_body as "fc.tut.s9.body" }